<p-button
  appPreventDoubleClick
  icon="fas fa-chevron-circle-right"
  pTooltip="Next Phase"
  id="changeControlNextPhaseButton"
  iconPos="left"
  (debounceClick)="moveToNextPhase()"
  tooltipPosition="left"
></p-button>
